export default __webpack_public_path__ + "static/media/notification-list-desktop.bdccb1d1.png";